import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_DETENTION_TYPE_URL } from '../../connection.data';

@Injectable()
export class DetentionTypeService extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_DETENTION_TYPE_URL;
    }
}